import { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Mission() {
  useEffect(() => {
    window.scrollTo(0, 0);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('fade-in-up');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.mission-block')
      .forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="mission-page">
      {/* Hero */}
      <section className="mission-hero">
        <div className="container">
          <div className="mission-hero-text">
            <span className="section-tag">Om oss</span>
            <h1>Vi tror p&aring; kraften i gemenskap.</h1>
            <p>
              Vi Tillsammans &auml;r en ideell f&ouml;rening som skapar kostnadsfria
              h&ouml;gtidsevent f&ouml;r m&auml;nniskor i ekonomisk och social utsatthet.
              Genom mat, aktiviteter, musik och omtanke vill vi skapa trygga
              m&ouml;tesplatser d&auml;r m&auml;nniskor k&auml;nner sig v&auml;lkomna,
              inkluderade och sedda.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="mission-content">
        <div className="container">
          <div className="mission-block">
            <h2>Om oss</h2>
            <p>
              F&ouml;r oss handlar gemenskap om mer &auml;n bara ett event. Det handlar
              om att skapa stunder d&auml;r m&auml;nniskor f&aring;r m&ouml;jlighet att
              k&auml;nna v&auml;rme, gl&auml;dje och tillh&ouml;righet - oavsett
              bakgrund, &aring;lder eller livssituation.
            </p>
            <p>
              Idag drivs Vi Tillsammans helt ideellt av engagerade ungdomar och unga
              vuxna mellan 20-35 &aring;r. Styrelsen best&aring;r av fem tjejer
              och tillsammans med &ouml;ver 40 volont&auml;rer arbetar vi f&ouml;r att
              skapa meningsfulla upplevelser f&ouml;r m&auml;nniskor som beh&ouml;ver
              det som mest.
            </p>
          </div>

          <div className="mission-block">
            <h2>V&aring;r historia</h2>
            <p>
              Vi Tillsammans grundades av en d&aring; 20-&aring;rig tjej med en stark
              vilja att g&ouml;ra n&aring;got &aring;t ensamheten, fattigdomen och
              heml&ouml;sheten som m&aring;nga upplever under h&ouml;gtider.
            </p>
            <p>
              Samtidigt som m&aring;nga samlas med familj, mat och gemenskap finns det
              m&auml;nniskor som st&aring;r helt utan det. Det blev starten p&aring; ett
              mindre julevent med m&aring;let att skapa en varm och v&auml;lkomnande
              plats f&ouml;r m&auml;nniskor som annars riskerade att k&auml;nna sig
              ensamma under julen.
            </p>
            <p>
              Det som fr&aring;n b&ouml;rjan var t&auml;nkt som en eng&aring;ngsinsats
              v&auml;xte snabbt till n&aring;got st&ouml;rre. Fler m&auml;nniskor
              engagerade sig, fler volont&auml;rer ville hj&auml;lpa till och eventet
              utvecklades till en &aring;terkommande tradition.
            </p>
            <p>
              Med tiden v&auml;xte &auml;ven verksamheten vidare till p&aring;skevent
              och midsommarfiranden - alltid med samma grundtanke: att ingen
              ska beh&ouml;va k&auml;nna sig ensam under &aring;rets viktigaste stunder.
            </p>
            <p>
              H&ouml;sten 2025 blev Vi Tillsammans (tidigare Jul Tillsammans) en
              registrerad ideell f&ouml;rening.
            </p>
          </div>

          <div className="mission-block">
            <h2>Det h&auml;r arbetar vi f&ouml;r</h2>
            <p>
              Vi vill motverka ensamhet och utanf&ouml;rskap genom att skapa trygga
              och inkluderande sammanhang d&auml;r m&auml;nniskor f&aring;r m&ouml;jlighet
              att samlas och k&auml;nna gemenskap.
            </p>
            <p>
              F&ouml;r oss handlar arbetet inte bara om att erbjuda mat eller
              aktiviteter. Det handlar om att skapa m&auml;nskliga m&ouml;ten och ge
              m&auml;nniskor en plats d&auml;r de k&auml;nner sig v&auml;lkomna precis
              som de &auml;r.
            </p>
            <p><strong>Vi vill:</strong></p>
            <ul className="mission-list-clean">
              <li>ge barn gl&auml;dje och fina minnen</li>
              <li>skapa trygghet f&ouml;r familjer och ensamst&aring;ende f&ouml;r&auml;ldrar</li>
              <li>erbjuda heml&ouml;sa en varm m&aring;ltid och gemenskap</li>
              <li>skapa m&ouml;tesplatser d&auml;r m&auml;nniskor k&auml;nner sig sedda och inkluderade</li>
              <li>sprida hopp, v&auml;rme och omtanke under &aring;rets mest k&auml;nsliga perioder</li>
            </ul>
            <p>
              Vi tror att sm&aring; handlingar kan g&ouml;ra stor skillnad. Ett varmt
              bem&ouml;tande, ett samtal eller en plats vid ett bord kan betyda mer
              &auml;n man tror.
            </p>
          </div>

          <div className="mission-block">
            <h2>V&aring;ra event</h2>
            <p>
              Vi arrangerar kostnadsfria event d&auml;r m&auml;nniskor kan samlas i en
              varm och familj&auml;r milj&ouml;.
            </p>
            <p><strong>P&aring; v&aring;ra event kan du bland annat f&ouml;rv&auml;nta dig:</strong></p>
            <ul className="mission-list-clean">
              <li>Gratis mat, fika och dryck</li>
              <li>Aktiviteter f&ouml;r b&aring;de barn och vuxna</li>
              <li>Livemusik och underh&aring;llning</li>
              <li>G&aring;vor och &ouml;verraskningar</li>
              <li>Barberare och fris&ouml;rer</li>
              <li>Lek, pyssel och familjeaktiviteter</li>
              <li>En trygg och v&auml;lkomnande atmosf&auml;r</li>
              <li>Gemenskap med plats f&ouml;r skratt, samtal och nya m&ouml;ten</li>
            </ul>
            <p>
              Varje event planeras med omtanke f&ouml;r att skapa en upplevelse
              d&auml;r m&auml;nniskor f&aring;r k&auml;nna sig inkluderade och
              uppskattade.
            </p>
          </div>

          <div className="mission-block mission-cta">
            <h2>Vill du vara med?</h2>
            <p>Varje bidrag r&auml;knas - vare sig det &auml;r tid, pengar eller att sprida ordet.</p>
            <div className="mission-cta-buttons">
              <Link to="/bidra" className="btn btn-primary">Bidra</Link>
              <Link to="/anmalan" className="btn btn-secondary">Anm&auml;l dig</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Mission;
